import { PostCardShelfTalker } from './post-card-shelf-talker';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { ShelfTalkerCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/shelf-talker-card-content.component';
import { GroupedByBrandShelfTalkerCardData } from '../../../../shelf-talkers/grouped-by-brand-shelf-talker-card-data';
import { GlassHouseShelfTalkerPostCardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/post-cards-4x6/glass-house-shelf-talker-post-card-background/glass-house-shelf-talker-post-card-background.component';
import { GlassHouseShelfTalkerPostCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/post-cards-4x6/glass-house-shelf-talker-post-card-content/glass-house-shelf-talker-post-card-content.component';

export class GlassHousePostCardShelfTalker extends PostCardShelfTalker {
  getCardBackgroundComponent(data: GroupedByBrandShelfTalkerCardData): Type<CardBackgroundComponent> {
    return GlassHouseShelfTalkerPostCardBackgroundComponent;
  }

  getCardContentComponent(data: GroupedByBrandShelfTalkerCardData): Type<ShelfTalkerCardContentComponent> {
    return GlassHouseShelfTalkerPostCardContentComponent;
  }

  public nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
